var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wallet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.603,
    height: 27.173,
    viewBox: "0 0 28.603 27.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Wallet-2",
    "data-name": "Wallet",
    d: "M8.312,27.173A8.418,8.418,0,0,1,0,18.672V8.5A8.418,8.418,0,0,1,8.312,0H20.29A8.418,8.418,0,0,1,28.6,8.5V18.672a8.418,8.418,0,0,1-8.312,8.5ZM2.079,8.5V18.672a6.312,6.312,0,0,0,6.234,6.374H20.29a6.312,6.312,0,0,0,6.234-6.374v-.4H21.952a4.881,4.881,0,0,1-.26-9.747l.261-.008h4.571V8.5A6.312,6.312,0,0,0,20.29,2.126H8.312A6.312,6.312,0,0,0,2.079,8.5Zm17.183,4.9a2.729,2.729,0,0,0,2.482,2.744l.21.008h4.571v-5.5H21.953A2.722,2.722,0,0,0,19.262,13.4Zm2.893.977a1.065,1.065,0,0,1-.14-2.117l.14-.009h.432a1.065,1.065,0,0,1,.142,2.116l-.142.01ZM7.325,8.558a1.065,1.065,0,0,1-.14-2.116l.14-.01h7.482a1.065,1.065,0,0,1,.142,2.116l-.142.01Z",
    fill: "#f6f6f9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon2);
export default __webpack_public_path__ + "static/media/wallet-icon-2.fda158cc0becbdc24f2b9d26a8972c7a.svg";
export { ForwardRef as ReactComponent };